import { css } from '@emotion/css';

export const themeButton = css`
  label: theme-button;
  margin-left: -2px;
`;
